// Sprint 1 — Wiki Freshness view.
// Plan §4.3 + §13. /api/v2/wiki/freshness

import { escHtml } from '../utils.js';

interface FreshnessEntry {
  scope: string;
  projectPath: string;
  lastUpdate: string | null;
  freshnessLevel: 'fresh' | 'warning' | 'stale' | 'critical';
  fileCount: number;
}

interface FreshnessSummary {
  total: number;
  byLevel: Record<string, number>;
  staleProjects: FreshnessEntry[];
}

let summary: FreshnessSummary | null = null;
let entries: FreshnessEntry[] = [];

export async function loadWikiFreshness(): Promise<void> {
  try {
    const r = await fetch('/api/v2/wiki/freshness');
    const j = await r.json() as { ok: boolean; summary: FreshnessSummary; entries: FreshnessEntry[] };
    summary = j.summary;
    entries = j.entries;
  } catch {
    summary = null;
    entries = [];
  }
}

export function renderWikiFreshness(): void {
  const root = document.getElementById('view-wiki-freshness');
  if (!root) return;
  if (!summary) {
    root.innerHTML = '<div class="view-header"><div class="view-title">Wiki Freshness</div></div><div class="empty-state">Yükleniyor…</div>';
    return;
  }
  const s = summary;
  root.innerHTML = `
    <div class="view-header">
      <div>
        <div class="view-title">Wiki Freshness</div>
        <div class="view-sub">Müşteri / iç proje / ürün hafıza güncelliği</div>
      </div>
    </div>
    <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;">
      ${chip('fresh', s.byLevel.fresh ?? 0, '#10b981')}
      ${chip('warning', s.byLevel.warning ?? 0, '#f59e0b')}
      ${chip('stale', s.byLevel.stale ?? 0, '#ef4444')}
      ${chip('critical', s.byLevel.critical ?? 0, '#dc2626')}
    </div>
    <div class="rt-card" style="margin-top:12px;">
      <div class="rt-card-title">Tüm projeler (${entries.length})</div>
      ${entries.length === 0
        ? '<div class="empty-state"><div class="empty-icon">📂</div><div class="empty-title">Henüz tarama yok — wiki/customers, wiki/internal, wiki/products altında klasör oluşturun.</div></div>'
        : `<table style="width:100%;font-size:13px;"><thead><tr><th>Scope</th><th>Path</th><th>Son güncelleme</th><th>Freshness</th><th>Dosya</th></tr></thead><tbody>${entries.map(e => `<tr><td>${escHtml(e.scope)}</td><td>${escHtml(e.projectPath)}</td><td>${escHtml(e.lastUpdate ?? '—')}</td><td>${escHtml(e.freshnessLevel)}</td><td>${e.fileCount}</td></tr>`).join('')}</tbody></table>`
      }
    </div>
  `;
}

function chip(label: string, count: number, color: string): string {
  return `<div class="rt-card" style="border-left:4px solid ${color};padding:14px;">
    <div style="font-size:11px;color:var(--muted);text-transform:uppercase;">${escHtml(label)}</div>
    <div style="font-size:24px;font-weight:600;margin-top:6px;">${count}</div>
  </div>`;
}
